(function() {
    'use strict';
    
a3_cabin_reports.controller('SearchFlightsCtrl', SearchFlightsCtrl);
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name SearchFlightsCtrl
    * @description 
    *   Search Flight info modal
    * @ngInject
    */ 
function SearchFlightsCtrl($scope, $uibModalInstance, $route, $location, defaultCalendarDate, SearchFlightsFactory, GroundDutyFactory, FlightFactory) {			
		
    $scope.showContent = 'search';
    $scope.hasError = false;
    $scope.flightFound = null;

    $scope.searchFlights = searchFlights;
    $scope.searchCriteriaContent = searchCriteriaContent;
    $scope.closeModal = closeModal;
    $scope.gotoSelectedFlightInfo = gotoSelectedFlightInfo;
    $scope.validationFormError = '';
    $scope.hasPublishedRoster = true;

    //Date picker:
    $scope.openDatepicker = openDatepicker;
    var today = new Date().toUTC();
    if (defaultCalendarDate) {
        today = new Date(defaultCalendarDate).toUTC();
    }
    function openDatepicker() {
        $scope.searchCriteria.flightDatePicker.opened = true;
    }
    updateSearchCriteriaScope();
 
    function updateSearchCriteriaScope(){
        var fromDate = null;
        var toDate = null;   
    
        var groundDutyDates = GroundDutyFactory.getFirstAndLastDateOfGroundDuties();
        var flightDates = FlightFactory.getTheFirstAndTheLastFlightDates();
    
        if (groundDutyDates && flightDates && groundDutyDates.firstDate && flightDates.firstDate) {
            fromDate = groundDutyDates.firstDate < flightDates.firstDate ? groundDutyDates.firstDate : flightDates.firstDate;
            toDate = groundDutyDates.lastDate > flightDates.lastDate ? groundDutyDates.lastDate : flightDates.lastDate;
        }
        else if (flightDates && flightDates.firstDate) {
            fromDate = flightDates.firstDate;
            toDate = flightDates.lastDate;
        }
        else if (groundDutyDates && groundDutyDates.firstDate) {
            fromDate = groundDutyDates.firstDate;
            toDate = groundDutyDates.lastDate;
        }
        else{
            $scope.hasPublishedRoster = false;
            $scope.showContent="results"
            $scope.hasError = true;
        } 
    
        $scope.searchCriteria = {
            flightDatePicker: {
                value: today,
                format: 'dd-MM-yyyy',
                opened: false,
                options: {
                    minDate: fromDate,
                    maxDate: toDate
                }
            },
            flightNo: "",
            departure: "",
            arrival:""
        }
    }

    function searchFlights() {
        $scope.hasError = false;
        if($scope.searchCriteria.flightNo.length==0 &&
            $scope.searchCriteria.departure.length==0 &&
            $scope.searchCriteria.arrival.length==0 )
        {
            $scope.validationFormError = 'Ensure that at least one optional value is provided.'
        }
        else{
            $scope.showContent = 'loading';
            
            SearchFlightsFactory.getFlights($scope.searchCriteria) 
                .then(res => handleResponse(res))
                .catch(res => handleFailedResponse(res));
        }
    }

    function handleResponse(res) {
        $scope.showContent = 'results';
        if (res.data && res.data.success && res.data.data) {
            $scope.flightsFound = res.data.data;

            //auto redirect when only one flight in results:
            // if($scope.flightsFound.lenght == 1){
            //     gotoSelectedFlightInfo($scope.flightsFound[0].flightId, $scope.flightsFound[0].flightDate, $scope.flightsFound[0].flightNo, $scope.flightsFound[0].departure);
            // }
        } else {
            $scope.hasError = true;
        }

    }

    function handleFailedResponse(res) {
        $scope.showContent = 'results';
        $scope.hasError = true;
    }	


    function searchCriteriaContent(){
        $scope.showContent = 'search';
    }

    /**
     * Redirect to selected flight info
     */
    function gotoSelectedFlightInfo(flightId, flightDate, flightNo, departure) {
        closeModal();
        $location.path('/selectedflightinfo/' + flightId + '/' + flightDate + '/' + flightNo+ '/' + departure);
    }

    /**
     * Close the modal
     * @memberof SearchPastGDCtrl
     */
    function closeModal() {
        $uibModalInstance.close('cancel');
    }  

}})();